<script setup lang="ts">
import { computed } from 'vue'
import MessageLoading from './MessageLoading.vue'
import AutoPlayButton from './AutoPlayButton.vue'
import type { Chat, Message } from '@/types'
import MessageRow from '@/components/MessageRow.vue'

interface Props {
  chat: Chat
  message: Message | undefined
  waitingResponse: boolean
  height: number
  isLoggedIn: boolean
  error: boolean
}

interface Emits {
  (e: 'needOpenAuthModal'): void
}

const props = defineProps<Props>()
defineEmits<Emits>()

const bottomOffset = computed(() => {
  const { height } = props
  return height + (props.waitingResponse ? 36 : 0)
})
</script>

<template>
  <div
    class="relative flex flex-col justify-end gap-4 z-100"
    :style="{ height: `calc(100% - ${bottomOffset}px)` }"
  >
    <auto-play-button
      :autoplay="true"
    />
    <message-row
      v-if="message"
      :chat-id="chat.chatId"
      :message="message"
    />
    <message-loading
      v-if="waitingResponse"
      :bottom-offset="bottomOffset"
    />
  </div>
</template>

<style scoped>
ion-action-sheet.my-custom-class {
  --background: var(--my-color-surface);
  --backdrop-opacity: 0.6;
  --button-background-selected: var(--my-color-surface);
  --button-color: var(--ion-text-color);
}
</style>
